import { createAction } from 'redux-api-middleware';
import { handleError } from '../utils';

export const FETCH_TRANSACTION_RATES_REQUEST = 'FETCH_TRANSACTION_RATES_REQUEST';
export const FETCH_TRANSACTION_RATES_SUCCESS = 'FETCH_TRANSACTION_RATES_SUCCESS';
export const FETCH_TRANSACTION_RATES_FAILURE = 'FETCH_TRANSACTION_RATES_FAILURE';

export const fetchTransactionRates = transaction =>
  createAction({
    endpoint: `${window.config.apiUrl}/transactions/rates`,
    method: 'POST',
    body: JSON.stringify(transaction),
    types: [
      FETCH_TRANSACTION_RATES_REQUEST,
      {
        type: FETCH_TRANSACTION_RATES_SUCCESS,
        payload: (action, state, res) => res.json(),
      },
      { type: FETCH_TRANSACTION_RATES_FAILURE, payload: handleError },
    ],
  });
